
import { Vue, Prop, Component, Watch } from "vue-property-decorator";

import InputRangeFilter from "@/components/filters/InputRangeFilterNew.vue";
import UiButton from "@/components/button/ui-button.vue";
import TitlesMultiselect from "@/components/autocompleteMultiselects/TitlesMultiselectNew.vue";
import SkillsMultiselect from "@/components/autocompleteMultiselects/SkillsMultiselectNew.vue";
import FormGroup from "@/components/form/FormGroupNew.vue";
import ProfileCountrySelect from "@/components/autocompleteMultiselects/ProfileCountrySelectNew.vue";
import UserCityMultiselect from "@/components/autocompleteMultiselects/UserCitiesMultiselectNew.vue";

import RadioOption from "@/entities/RadioOption";
import DropdownOption from "@/entities/DropdownOption";
import marketplaceFiltersTemplate from "@/data/filtersTemplates/marketplaceFiltersTemplate";
import getMultiselectValues from "@/helpers/multiselect/getMultiselectValues";
import MarketplaceFiltersQuery from "@/entities/filters/MarketplaceFiltersQuery";
import radioOptions from "@/data/filters/radioOptions";
import ProfileAvailabilitySelect from "@/components/autocompleteMultiselects/ProfileAvailabilitySelect.vue";
import RegionInput from "@/components/autocompleteMultiselects/RegionInputCustom.vue";
import UiButtonMessage from "@/components/button/ui-button-message.vue";

@Component({
  components: {
    RegionInput,
    InputRangeFilter,
    UiButtonMessage,
    UiButton,
    TitlesMultiselect,
    SkillsMultiselect,
    FormGroup,
    UserCityMultiselect,
    ProfileAvailabilitySelect,
    ProfileCountrySelect,
  },
})
export default class MarketplaceFilters extends Vue {
  @Prop({ type: Boolean, default: false }) readonly hideFromManager!: boolean;
  @Prop({ type: Object, required: true })
  readonly filters!: MarketplaceFiltersQuery;

  countries: DropdownOption[] = [];
  states: DropdownOption[] = [];
  cities: DropdownOption[] = [];
  titles: DropdownOption[] = [];
  skillsIds: number[] = [];
  name: string = "";
  minRate: string = "";
  maxRate: string = "";
  available: string = marketplaceFiltersTemplate.available;
  suitable_resources: boolean = false;
  excludeResource: string = "";

  radioOptions: RadioOption[] = radioOptions;

  get countryName(): string {
    return this.countries[0]?.name || "";
  }

  get countriesNames(): string[] {
    return this.countries.map((country) => country.name);
  }

  get statesNames(): string[] {
    return this.states.map((state) => state.name);
  }

  get citiesNames(): string[] {
    return this.cities.map((city) => city.name);
  }

  get titlesNames(): string[] {
    return this.titles.map((title) => title.name);
  }

  get propToWatch(): string {
    return JSON.stringify([
      this.name,
      this.available,
      this.minRate,
      this.maxRate,
      this.countriesNames,
      this.statesNames,
      this.citiesNames,
      this.titlesNames,
      this.skillsIds,
    ]);
  }

  @Watch("propToWatch")
  handlePropToWatchChange(): void {
    this.$emit("filtersChanged", {
      countries: this.countriesNames,
      states: this.statesNames,
      cities: this.citiesNames,
      titles: this.titlesNames,
      skills: this.skillsIds,
      name: this.name,
      minRate: this.minRate,
      maxRate: this.maxRate,
      available: this.available,
      suitableResources: this.filters.suitableResources,
      excludeResource: this.filters.excludeResource,
    });
  }

  @Watch("filters", { immediate: true })
  updateFiltersValues(): void {
    this.countries = getMultiselectValues(this.filters.countries);
    this.states = getMultiselectValues(this.filters.states);
    this.cities = getMultiselectValues(this.filters.cities);
    this.titles = getMultiselectValues(this.filters.titles);
    this.skillsIds = this.filters.skills;
    this.name = this.filters.name;
    this.available = this.filters.available;
    this.minRate = this.filters.minRate;
    this.maxRate = this.filters.maxRate;
    this.suitable_resources = this.filters.suitableResources;
    this.excludeResource = this.filters.excludeResource;
  }

  handleReset(): void {
    this.$emit("resetFilters");
  }
}
